module.exports = __webpack_public_path__ + "media/assets/icons/office-f95b81cddc60403d0deb13abb4b5250e.svg";